import { Component, Input, OnInit } from '@angular/core';
import { Estacao } from '../../models/estacao.model';

@Component({
  selector: 'app-dados-estacao',
  templateUrl: './dados-estacao.component.html',
  styleUrls: ['./dados-estacao.component.scss'],
})
export class DadosEstacaoComponent implements OnInit {

  @Input() isEstacaoPrincipal: boolean;
  @Input() estacao: Estacao;

  constructor() { }

  ngOnInit() {
    this.estacao.dtUltimaAtualizacao = this.estacao.dtUltimaAtualizacao.replace(/\s/g, 'T');
  }

}
